/**
 * @desc 发放标准设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.UpdateStandardRequest,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/web/labour/updateStandard',
    data,
  });
}

export function mock(
  data: defs.UpdateStandardRequest,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/mock/web/labour/updateStandard',
    data,
  });
}
